import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-link-external",
  templateUrl: "./med-icon-link-external.component.html",
})
export class MedIconLinkExternalComponent extends SvgMixinComponent {}
